import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AILawncarePage = lazy(() => import('../pages/ai-lawncare/page'));
const AILawncareEligibilityPage = lazy(() => import('../pages/ai-lawncare-eligibility/page'));
const QualifiedBookingPage = lazy(() => import('../pages/qualified-booking/page'));
const CaseStudiesPage = lazy(() => import('../pages/case-studies/page'));
const WinterEvaluationPage = lazy(() => import('../pages/winter-evaluation/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
import InstantBookingPage from '../pages/instant-booking/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/ai-lawncare',
    element: <AILawncarePage />,
  },
  {
    path: '/ai-lawncare-eligibility',
    element: <AILawncareEligibilityPage />,
  },
  {
    path: '/qualified-booking',
    element: <QualifiedBookingPage />,
  },
  {
    path: '/case-studies',
    element: <CaseStudiesPage />,
  },
  {
    path: '/winter-evaluation',
    element: <WinterEvaluationPage />,
  },
  {
    path: "/instant-booking",
    element: <InstantBookingPage />
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
